<template>
    <div>
        <v-card class="token-card" v-if="token">
            <v-card-text>
                <v-row align="center" justify="space-between">
                    <v-col cols="auto">
                        <span class="token-text">Token No: {{ token?.appointmentId }}</span>
                    </v-col>
                    <v-col cols="auto" v-if="isCancelable" @click="confirmCancellation">
                        <v-btn class="cancel-btn" color="error">Cancel</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-title>
                <span class="card-title"> {{ token?.masterServiceName }}</span>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <!-- <v-col cols="6" v-if="token?.childServiceName">
            <span class="text-column">{{ token?.childServiceName }}</span>
          </v-col> -->
                    <v-col cols="6" class="text-right">
                        <span class="text-column">
                            {{ token?.branchName?.toUpperCase() }} Branch</span>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider class="divider"></v-divider>
            <v-card-text>
                <v-row>
                    <v-col cols="6">
                        <v-icon class="calendar-icon icon">mdi-calendar-blank-outline</v-icon>
                        <span class="text-column date-text">{{ appointmentDate }}</span>
                    </v-col>
                    <v-col cols="6" class="text-right">
                        <v-icon class="clock-icon icon">mdi-clock-outline</v-icon>
                        <span class="text-column time-period-text">
                            {{ openingTime + " - " + closingTime }}</span>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-dialog v-model="dialogVisible" max-width="400">
            <v-card>
                <v-card-title class="headline">Cancel Token</v-card-title>
                <v-card-text class="red--text">
                    You can cancel your token before the selected date and time
                </v-card-text>
                <v-card-text>
                    Do you want to cancel Token {{ token?.appointmentId }}?
                </v-card-text>
                <v-card-actions>
                    <v-btn color="error" text @click="cancelAppointment">Yes</v-btn>
                    <v-btn text @click="closeDialog">No</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script lang="ts">
export default {
    name: "TokenCard",
    props: {
        cancelable: {
            type: Boolean,
            default: false
        },
        token: {
            type: Object,
        }
    },
    data() {
        return {
            selectedLanguage: "Eng",
            langs: ["Eng", "Myn"],
            dialogVisible: false,
            isCancelable: false,
            appointmentDate: '',
            openingTime: '',
            closingTime: ''
        };
    },
    mounted() {
        this.appointmentDate = this.convertDateFormat(this.token.appointmentDate);
        this.openingTime = this.formatTime(this.token.openingTime);
        this.closingTime = this.formatTime(this.token.closingTime);
        if (this.cancelable && this.isDateEqualToCurrentDate(this.appointmentDate) && this.isTimeCrossed(this.token.openingTime)) {
            this.isCancelable = false;
        } else if (this.cancelable) {
            this.isCancelable = true;
        }
    },

    methods: {
        confirmCancellation() {
            this.dialogVisible = true;
        },

        cancelAppointment() {
            this.dialogVisible = false;
            console.log("token card cancelAppointment event")
            this.$emit('cancel-appointment', this.token);
        },

        closeDialog() {
            this.dialogVisible = false;
        },

        isTimeCrossed(inputTime) {
            const timeObj = new Date(`2025-01-01T${inputTime}`);
            const timeObjToday = new Date();
            const hours = timeObj.getHours();
            const minutes = timeObj.getMinutes();
            const hoursNow = timeObjToday.getHours();
            const minutesNow = timeObjToday.getMinutes();
            return hours < hoursNow && minutes < minutesNow
        },

        isDateEqualToCurrentDate(dateString) {
            const currentDate = new Date();
            const [day, month, year] = dateString.split('-').map(Number);

            // JavaScript months are zero-indexed, so we subtract 1 from the month
            const inputDate = new Date(year, month - 1, day);

            return (
                inputDate.getDate() === currentDate.getDate() &&
                inputDate.getMonth() === currentDate.getMonth() &&
                inputDate.getFullYear() === currentDate.getFullYear()
            );
        },
        convertDateFormat(inputDate) {
            const parts = inputDate.split('-');
            if (parts.length === 3) {
                const month = parts[1];
                const day = parts[2];
                const year = parts[0];
                return `${day}-${month}-${year}`;
            } else {
                return inputDate; // Return the original format if input is invalid
            }
        },
        formatTime(inputTime) {
            const timeObj = new Date(`1970-01-01T${inputTime}`);
            const hours = timeObj.getHours();
            const minutes = String(timeObj.getMinutes()).padStart(2, "0");
            const period = hours >= 12 ? "PM" : "AM";
            const formattedHours = hours % 12 || 12;
            return `${formattedHours}:${minutes} ${period}`;
        }
    },
};
</script>

<style scoped>
.token-card {
    box-shadow: none;
    border-radius: 4px;
    border: 1px solid #bdbdbd;
    margin-bottom: 16px;
}

.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
}

.token-text {
    font-size: 12px;
    line-height: 20px;
    color: #333333;
}

.arrow-icon {
    font-size: 18px;
}

.card-title {
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    color: #0054a6;
}

.v-card__subtitle,
.v-card__text,
.v-card__title {
    padding: 0;
    word-break: break-word;
}

.v-card {
    padding: 16px;
    border-radius: 8px;
}

.v-card__title {
    margin-top: 5px;
}

.text-column {
    margin-top: 5px;
    font-size: 12px;
    line-height: 20px;
    color: #333333;
}

.text-right {}

.divider {
    margin-top: 8px;
    margin-bottom: 8px;
    border-top: 1.5px solid #bdbdbd;
}

.date-text,
.time-period-text {
    padding-left: 5px;
}

.icon {
    height: 16px;
    width: 16px;
    color: black;
    font-size: 16px;
}

.cancel-btn {
    text-transform: none;
    letter-spacing: 0;
    padding: 0px !important;
    height: 28px !important;
    font-size: 12px;
}
</style>

<style>
.v-application .text-right {
    text-align: left !important;
}
</style>
